export * from './static.module'
